// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gMyv","newExpiryDate":"styles_newExpiryDate__1VLzg","footer":"styles_footer__3zKUg"};